module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"summary":"나와 비슷한 체형은 {size}를 가장 많이 구매했어요","summary_size":"{size} 사이즈"}}')
  delete Component.options._Ctor
}
